import { render, staticRenderFns } from "./naoDeal.vue?vue&type=template&id=75e74fd6&scoped=true&"
import script from "./naoDeal.vue?vue&type=script&lang=js&"
export * from "./naoDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e74fd6",
  null
  
)

export default component.exports